<template>
  <div>
    <el-dialog
      title="管理投放渠道"
      :visible.sync="showDialog"
      width="50%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <div class="f-search-block">
          <el-form
            ref="form"
            :model="form"
            :inline="true"
          >
            <el-form-item
              label="渠道名称"
              prop="channel_name"
            >
              <el-input
                v-model="form.channel_name"
                placeholder="请输入渠道名称"
              />
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddChannel',
  props: {
    addChannelVisible: {
      type: Boolean,
      default: false
    },
    addChannelData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      form: {
        channel_name: ''
      },
      tableData: [],
      activity_id: 0
    }
  },
  computed: {
    showDialog () {
      return this.addChannelVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.selectValue = this.addChannelData
        this.activity_id = this.selectValue[1].activity_id
        console.log(this.activity_id)
      } else {
        this.selectValue = []
        this.form.channel_name = ''
      }
    }
  },
  created () {
    this.options = this.list
    this.codeOptions = this.codeList
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('addChannelVisibleChange', [false])
    },
    onSubmit () {
      console.log(this.form)
    },
    async handleConfirm () {
      const params = this.form
      params.activity_id = this.activity_id
      const data = await this.$api.formActivity.createChannel(params)
      if (data.status === true) {
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.cancelAction()
      }
    },
    handleCopy (value) {
      console.log(value)
    },
    handleDownload (value) {
      console.log(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
</style>
